module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-mv-imgline@2x-eeb7f2cdcfad0d66e892ccffc3b4bf0d.png";